<template>
  <div class="web-gl">
      <iframe width="100%" height="100%" src='/webgl/towerDistributionDiagram.html?v=123456' style="border: 0;height: 100%;"></iframe>
  </div>
</template>

<script>
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
    },
    methods:{

    }
}
</script>

<style scoped>
    .web-gl{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
    }
</style>

<style>

</style>